// Framework counting for the Security Insights Controls tab ("N/M" column, "N of M frameworks"
// header, "frameworks" sort). With industry scoping on (Features:GrcVerticalFrameworks and an
// organisation industry), a control is measured only against the industry's frameworks, the same
// set the GRC Framework Coverage card shows; without it, the count is every distinct framework.
//
// `mappings` are the control's frameworkMappings ({ framework: backend key, ref, description }).
// `backendToFwKey` maps a backend key (e.g. "NIST_CSF") to its display key (e.g. "nist_csf").
// `applicableKeys` is the industry's display-key list, or null when unscoped.

export function countFrameworks(mappings, backendToFwKey, applicableKeys) {
  const list = mappings || [];
  if (applicableKeys == null) {
    return new Set(list.map(m => m.framework)).size;
  }
  const keys = new Set();
  list.forEach(m => {
    const fk = backendToFwKey[m.framework];
    if (fk && applicableKeys.includes(fk)) keys.add(fk);
  });
  return keys.size;
}
